// 使用v-style ，设置html、body的自定义样式, v-style="{'height': '100%'}"
export default {
  inserted(el, binding) {
    const value = binding.value;
    for (const key in value) {
      document.documentElement.style[key] = value[key];
      document.body.style[key] = value[key];
    }
  },

  unbind(el, binding) {
    const value = binding.value;
    for (const key in value) {
      document.documentElement.style[key] = '';
      document.body.style[key] = '';
    }
  },
};
